import React from "react";

import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

import pantheon4 from "../../logos/photos/1.jpg"
import pantheon5 from "../../logos/photos/3.jpg"


export default function Bucharest() {

  
  return (
    <Layout>
      <Navbar  />
      <PageHeader />
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="about-content-left section-heading">
                <h3 style={{color:'#e95d04'}}>
               Pantheon Consortium Meets in Bucharest for the 6th General Assembly Meeting
                 </h3>
                <p>
               On June 26–27, 2025, the Pantheon project consortium gathered in Bucharest, Romania, for its
sixth General Assembly (GA) meeting, hosted by <a href='https://simavi.ro/en/home-2/'>Software Imagination & Vision (Simavi)</a>. As
the project approaches its final stage, the partners convened to review progress and plan the
successful conclusion of this ambitious initiative.</p>
                <p>During the two-day meeting, the consortium held in-depth technical workshops to refine key
project components. These sessions fostered active collaboration among partners, enabling
them to address remaining technical challenges and optimise system performance.</p>
<p>The Pantheon team is dedicated to finalising a community-based Smart City Digital Twin
platform for optimised disaster risk management operations and enhanced community disaster
resilience. The platform will integrate real-time and multi-source data to support evidence-based
policy-making, analysis, evaluation, and training.</p>
              </div>
            </div>
            <div className="col-md-5">
              <div className="about-content-right">
                <img
                  src={pantheon4}
                  style={{borderRadius:'10px'}}
                  alt="about us"
                  className="img-fluid"
                />
                <img
                  src={pantheon5}
                  style={{borderRadius:'10px'}}
                  alt="about us"
                  className="img-fluid"
                />
              
              </div>
            </div>
          </div>
        </div>
      </section>
  

      <Footer space />
    </Layout>
  );
}
